import _objectSpread from "@babel/runtime-corejs3/helpers/objectSpread2";
import lib from '.';
export default {
  key: 'properties',
  plugin: function plugin(properties, key, fullPath, specmap) {
    var val = _objectSpread({}, properties); // eslint-disable-next-line no-restricted-syntax, guard-for-in


    for (var k in properties) {
      try {
        val[k].default = specmap.modelPropertyMacro(val[k]);
      } catch (e) {
        var err = new Error(e);
        err.fullPath = fullPath; // This is an array

        return err;
      }
    }

    var patch = lib.replace(fullPath, val);
    return patch;
  }
};